import type { Strings } from '../../i18n/strings';

// Labels shared by the readiness banner, the head's School status and the
// platform admin's checklist (0020).
export function ownerLabel(t: Strings, owner: string): string {
  return owner === 'zencera' ? t['r4.owner.zencera'] : owner === 'head' ? t['r4.owner.head'] : t['r4.owner.school_admin'];
}

export function langList(t: Strings, codes: string[] | null | undefined): string {
  return (codes ?? []).map((c) => (c === 'fi' || c === 'sv' || c === 'en' ? t[`r4.lang.${c}`] : c.toUpperCase())).join(', ');
}
